import { createFileRoute } from "@tanstack/react-router";
import ResetPasswordForm from "@/ui/components/auth/reset-password";

export const Route = createFileRoute("/_auth/reset-password")({
  component: ResetPasswordForm,
});
